import * as React from "react";
import { EmailAddressesPage } from "./EmailAddressesPage";
import { EmailAddressesProvider } from "./context/EmailAddressesContext";

const EmailAddresses = () => (
	<EmailAddressesProvider>
		<EmailAddressesPage />
	</EmailAddressesProvider>
);

export default EmailAddresses;
